export const POPUP_BANNER_DEFAULT_BEST_DISPLAY = "1920 x 760px";
export const POPUP_BANNER_MAX_SIZE_UPLOAD = 5;
